import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-draw-section-form',
  templateUrl: './draw-section-form.component.html',
  styleUrls: ['./draw-section-form.component.scss']
})
export class DrawSectionFormComponent implements OnInit {


  @ViewChild('f', { static: false }) f : NgForm

  public data : any = {status: 1}
  constructor(private http: HttpService, private activatedRoute: ActivatedRoute) { 
    this.activatedRoute.params.subscribe(params => {
      this.loadData(params['uuid']);
    });
  }

  ngOnInit(): void {
  }

  async loadFile(fileInput: any, name: string) {
    this.data[name] = await this.http.fileChangeEvent(fileInput);
  }

  async submit() {
    
    const s = await this.http.post("/admin/draw-section/update", this.data);

    if (s['status']) {
      this.http.naviBack();
    } else {
      alert(s['message']);
    }
    
  }

  async loadData(section_uuid) {
    this.data = await this.http.post("/admin/draw-section/get", {section_uuid});
  }
}
